export const formatPageText = (text: string): string => {
  return text
}

export const extractCurrentPageContent = (fullContent: string, pageNum: number): string | null => {
  if (!fullContent) return null

  const headerPattern = /^## Page (\d+)$/gm
  const headers: { num: number; index: number }[] = []
  
  let match
  while ((match = headerPattern.exec(fullContent)) !== null) {
    headers.push({
      num: parseInt(match[1]),
      index: match.index
    })
  }
  
  if (headers.length === 0) {
    return fullContent
  }
  
  let targetHeader = headers.find(h => h.num === pageNum)
  
  if (!targetHeader && pageNum <= headers.length) {
    targetHeader = headers[pageNum - 1]
  }
  
  if (!targetHeader) {
    return fullContent
  }
  
  const currentIndex = headers.indexOf(targetHeader)
  const nextHeader = headers[currentIndex + 1]
  
  const startIndex = targetHeader.index
  const endIndex = nextHeader ? nextHeader.index : fullContent.length
  
  return fullContent.substring(startIndex, endIndex).trim()
}

export const processPageText = (
  rawContent: string | null, 
  currentPage: number, 
  extractPage: boolean = false
): string | null => {
  if (!rawContent) return null
  
  const formatted = formatPageText(rawContent)
  
  if (extractPage) {
    return extractCurrentPageContent(formatted, currentPage)
  }
  
  return formatted
}
